import * as cn from "classnames";
import * as React from "react";
import "./MetricSetTable.css";

export interface MetricSetData {
    metricLabels: string[];
    rows: MetricSetRow[];
}

export interface MetricSetRow {
    color?: string;
    title: string;
    metrics: string[];
}

export interface MetricSetTableProps {
    data: MetricSetData;
    className?: string;
}

export function MetricSetTable(props: MetricSetTableProps) {
    const { data } = props;

    return (
        <div className={cn("MetricSetTable", props.className)}>
            <div className="MetricSetTable__metric-set MetricSetTable__col">
                {data.rows.map(metric => (
                    <div
                        key={`MetricSetTable-metric-${metric.title}`}
                        className="MetricSetTable__metric MetricSetTable__item"
                    >
                        {metric.color && (
                            <span className="MetricSetTable__metric-color" style={{ backgroundColor: metric.color }}>
                                &nbsp;
                            </span>
                        )}{" "}
                        {metric.title}
                    </div>
                ))}
            </div>
            {data.metricLabels.map((label, index) => (
                <div
                    className="MetricSetTable__values additional MetricSetTable__col"
                    key={`MetricSetTable-AdditionalValueGroup-${index}`}
                >
                    <div className="MetricSetTable__value-header">{label}</div>
                    {data.rows.map(s => (
                        <div key={`MetricSetTableAdditionalValue-${index}-${s.title}`} className="MetricSetTable__item">
                            {(s.metrics || [])[index]}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
